// src/components/CTAButton.jsx
import React from 'react';

const CTAButton = ({ text, variant = 'primary', size = 'medium', type = 'button', onClick }) => {
    return (
        <button
            className={`cta-button ${variant} ${size}`}
            type={type}
            onClick={onClick}
        >
            {text}
        </button>
    );
};

export default CTAButton;